import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdDelete, MdEdit, MdStar } from "react-icons/md";
import { Button, Input, Modal, Pagination, Select, Spin, Tag } from "antd";
import CountUp from "react-countup";
import { phoneFormat } from "../../../services/functions";
import { HeaderTitle, Message, ViewInput } from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";
import userPhoto from "../../../images/user.png";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function FranqueadosAdmin() {
  const { confirm } = Modal;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [franqueados, setFranqueados] = useState([]);
  const [franqueadosTotal, setFranqueadosTotal] = useState(0);
  const [page, setPage] = useState(() => {
    return Number(searchParams.get("page")) || 0;
  });
  const [filter, setFilter] = useState("");
  const [type, setType] = useState(() => {
    return searchParams.get("type") || "";
  });
  const [filterSearch, setFilterSearch] = useState(() => {
    return searchParams.get("filter") || "";
  });

  useEffect(() => {
    const params = {
      page,
      filter: filterSearch,
      type,
    };
    setSearchParams(params, { replace: true });
    listFranqueados(page, filterSearch);
    window.scrollTo(0, 0);
  }, [type, page, filterSearch]);

  async function listFranqueados(page, filter) {
    setLoading(true);
    await api
      .get(
        `/users?page=${page}${filter ? `&filter=${filter}` : ""}${type ? `&type=${type}` : ""}`,
      )
      .then((response) => {
        setFranqueados(response.data.users);
        setFranqueadosTotal(response.data.usersTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function deleteFranqueado(id) {
    await api
      .delete(`/user/${id}`)
      .then(() => {
        toast.success(`Franqueado excluido com sucesso`);
        listFranqueados(page, filterSearch);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Franqueados</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/admin/ranking");
          }}
        >
          <MdStar size="20" color="#fff" />
          Ranking Franqueados
        </Button>
      </HeaderTitle>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp separator="." duration={1} end={franqueadosTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  setPage(0);
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  setPage(0);
                  setFilter("");
                }}
                enterButton
                style={{ borderRadius: 8 }}
              />
            </ViewInput>
            <ViewInput style={{ width: 200 }}>
              <p>Filtrar por Categoria</p>
              <Select
                value={type}
                style={{ width: "100%" }}
                onChange={(value) => {
                  setType(value);
                  setPage(0);
                }}
              >
                <Select.Option value="">Todas</Select.Option>
                <Select.Option value="franqueado">Franqueado</Select.Option>
                <Select.Option value="assinatura">Assinatura SST</Select.Option>
                <Select.Option value="revenda">Revenda</Select.Option>
                <Select.Option value="terceirize">Terceirize</Select.Option>
              </Select>
            </ViewInput>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                marginBottom: 5,
              }}
              onClick={() => {
                navigate("/admin/franqueado/new");
              }}
            >
              Novo Franqueado
            </Button>
          </div>
          <div className="orders">
            {franqueados.length == 0 && (
              <Message>Nenhum franqueado encontrado</Message>
            )}
            {franqueados.map((item) => {
              return (
                <div className="order">
                  <img src={item.photo ? item.photo_url : userPhoto} />
                  <div className="infos">
                    <p>
                      {item.name} - {phoneFormat(item.phone_number)}{" "}
                    </p>
                    {item.category == "franqueado" && (
                      <Tag
                        color="blue"
                        style={{
                          marginTop: 5,
                          width: 100,
                          textAlign: "center",
                        }}
                      >
                        Franqueado
                      </Tag>
                    )}
                    {item.category == "assinatura" && (
                      <Tag
                        color="green"
                        style={{
                          marginTop: 5,
                          width: 100,
                          textAlign: "center",
                        }}
                      >
                        Assinatura SST
                      </Tag>
                    )}
                    {item.category == "revenda" && (
                      <Tag
                        color="orange"
                        style={{
                          marginTop: 5,
                          width: 100,
                          textAlign: "center",
                        }}
                      >
                        Revenda
                      </Tag>
                    )}
                    {item.category == "terceirize" && (
                      <Tag
                        color="purple"
                        style={{
                          marginTop: 5,
                          width: 100,
                          textAlign: "center",
                        }}
                      >
                        Terceirize
                      </Tag>
                    )}
                    <p style={{ color: "#0008", marginTop: 5 }}>{item.email}</p>
                  </div>
                  <div className="actions">
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/contracts/${item.id}`);
                      }}
                    >
                      Propostas
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/orders?cliente=${item.id}`);
                      }}
                    >
                      OSs
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/financeiro-cliente/${item.id}`);
                      }}
                    >
                      Financeiro
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/services-os/${item.id}`);
                      }}
                    >
                      Serviço OSs
                    </Button>
                    <Button
                      type="primary"
                      className="warning-button"
                      onClick={() => {
                        navigate(`/admin/franqueado/${item.id}`);
                      }}
                    >
                      <MdEdit color="#FFF" size={16} />
                      Editar
                    </Button>
                    <Button
                      type="primary"
                      className="delete-button"
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: `Deseja excluir o franqueado"
                          } ${item.name}?`,
                          icon: <ExclamationCircleFilled />,
                          content: `Após confirmação, o franqueado será excluido`,
                          onOk() {
                            deleteFranqueado(item.id);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      <MdDelete color="#FFF" size={16} />
                      Excluir
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={franqueadosTotal}
          />
        </>
      )}
    </Container>
  );
}
